import {
  BusinessProfileOption,
  CompanyCreationModes,
  CompanyCreationSteps,
  FranchiseOption,
} from '../../../../../views/companies';
import { BusinessType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nuevo restaurante',
  sections: {
    new_company: {
      titles: {
        [CompanyCreationModes.demo]: 'Nueva demo',
        [CompanyCreationModes.full]: 'Nuevo restaurante',
      },
      steps: {
        [CompanyCreationSteps.CompanyInfo]: 'Info del restaurante',
        [CompanyCreationSteps.BusinessInfo]: 'Info del negocio',
        [CompanyCreationSteps.AdditionalLocations]: 'Restaurantes adicionales',
      },
    },
    business_profile: {
      legal_info: 'Info legal',
      owner_info: 'Info del propietario',
    },
    recently_created: 'Creados recientemente',
  },
  form: {
    franchise: {
      label: 'Crear restaurante',
      tooltip:
        'Selecciona si estás creando una marca completamente nueva o añadiendo este restaurante a una marca ya existente en nuestro sistema.',
      options: {
        [FranchiseOption.CreateFranchise]: {
          title: 'Crear una nueva marca',
          tooltip: 'Empezamos de cero: sin marca ni restaurante existente',
        },
        [FranchiseOption.UseExistingFranchise]: {
          title: 'Añadir este restaurante a una marca existente',
          tooltip: 'Ya pertenece a una marca del sistema',
        },
      },
    },
    restaurants: {
      label: 'Restaurante(s) asociado(s)',
    },

    business_profile: {
      label: '¿Quién es el propietario?',
      tooltip:
        '¿Pertenece este restaurante a un propietario/empresa que ya existe en el sistema (p. ej., «Luís Pizza GmbH»)? <br/> Si es así, selecciona ese perfil existente. De lo contrario, crea un nuevo perfil de propietario/empresa.',
      options: {
        [BusinessProfileOption.CreateBusinessProfile]: 'Crear nuevo perfil de propietario/empresa',
        [BusinessProfileOption.UseExistingBusinessProfile]: 'Usar perfil de propietario/empresa existente',
      },
    },
    business_type: {
      label: 'Tipo de empresa',
      placeholder: 'Selecciona el tipo de empresa',
      options: {
        [BusinessType.Company]: 'Empresa',
        [BusinessType.Individual]: 'Autónomo',
      },
    },
    display_name: {
      label: 'Nombre del restaurante',
      placeholder: 'Nombre amigable',
    },
    legal_name: {
      label: 'Nombre legal',
      placeholder: 'Nombre legal',
    },
    owner_first_name: {
      label: 'Nombre del contacto',
      placeholder: 'James',
    },
    owner_last_name: {
      label: 'Apellido del contacto',
      placeholder: 'Bond',
    },
    owner_phone_number: {
      label: 'Teléfono del contacto',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Correo del contacto',
      placeholder: 'Introduce el correo',
    },
    password: {
      label: 'Contraseña',
      placeholder: 'Introduce la contraseña',
    },

    additional_companies: {
      label: 'Restaurantes adicionales bajo esta marca',
      tooltip:
        '¿Hay restaurantes adicionales bajo la misma marca que {{company}}? <br/> Si es así, haz clic en «Añadir restaurante» para incluir más locales. Si es el mismo propietario pero diferente marca, no lo añadas aquí; créalo por separado.',
    },
  },
  labels: {
    create_demo: 'Crear demo',
    create_company: 'Crear restaurante',
    business_type: 'Tipo de empresa',
    display_name: 'Nombre amigable',
    legal_name: 'Nombre legal',
    owner_name: 'Nombre del propietario',
    address: 'Dirección',
  },
  fields: {
    name: 'Nombre',
    created_at: 'Creado',
    actions: 'Acciones',
  },

  buttons: {
    add_restaurant: '+ Añadir restaurante',
    continue: 'Continuar',
    back: 'Atrás',
    create: 'Crear restaurante',
    delete: 'Eliminar',
  },
  popups: {
    delete_demo: {
      title: '¿Seguro que deseas eliminar?',
    },
  },
  toasts: {
    company_created: 'Restaurante creado correctamente',
    failed_to_create_company: 'Error al crear el restaurante',
    failed_to_delete_demo: 'Error al eliminar la demo',
    demo_got_deleted: 'Demo eliminada correctamente',
    failed_to_load_recently_created_companies: 'Error al cargar los restaurantes creados recientemente',
  },
};
